import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import {
  CustomButton,
  CustomInputSelect,
  CustomTextInput,
} from '@Modules/core/components';
import { FaPrint } from 'react-icons/fa';
import { ICardsNumberByStatusReasonAndCardNetworkTypeMeta } from '@Modules/reporting/containers/forms/cardManagementSystem/cardholders/cardsNumberByStatusReasonAndCardNetworkType/CardsNumberByStatusReasonAndCardNetworkTypeMeta';
import CustomFormControl from '@Modules/core/components/form/CustomFormControl';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

type Props = {
  onSubmit: any,
  meta: ICardsNumberByStatusReasonAndCardNetworkTypeMeta,
  isLoading?: boolean,
  isSubmitting?: boolean,
} 

export const CardsNumberByStatusReasonAndCardNetworkTypeFormUI = ({onSubmit, isLoading, isSubmitting, meta}: Props) => {

  const {
      register,
      handleSubmit,
      formState: { errors },
      // reset,
    } = useForm({ resolver: yupResolver(meta.schema),});


  return (
    <>
      <CC.Heading as="h1" size={'md'} fontWeight="normal" mb="1%">
        Nombre de cartes par motif de statut et type reseau carte
      </CC.Heading>

      <form onSubmit={handleSubmit(onSubmit)}>

        <CC.SimpleGrid columns={{base: 1, sm:1, md: 2, lg:3}} spacing={10} my={10}>
            
          <CustomFormControl
            label={meta.bank.label}
            isLoading={isLoading}
            isInvalid={!!errors[meta.bank.name]}
          >
            <CustomInputSelect
              meta={meta.bank}
              register={register(meta.bank.name)}
              hasError={errors[meta.bank.name]}
            />
          </CustomFormControl>
          
          <CustomFormControl
            label={meta.agency.label}
            isLoading={isLoading}
            isInvalid={!!errors[meta.agency.name]}
          >
            <CustomInputSelect
              meta={meta.agency}
              register={register(meta.agency.name)}
              hasError={errors[meta.agency.name]}
            />
          </CustomFormControl>

          <CustomFormControl
            label={meta.cardNetworkType.label}
            isLoading={isLoading}
            isInvalid={!!errors[meta.cardNetworkType.name]}
          >
            <CustomInputSelect
              meta={meta.cardNetworkType}
              register={register(meta.cardNetworkType.name)}
              hasError={errors[meta.cardNetworkType.name]}
            />
          </CustomFormControl>

          <CustomFormControl
            label={meta.cardStatus.label}
            isLoading={isLoading}
            isInvalid={!!errors[meta.cardStatus.name]}
          >
            <CustomInputSelect
              meta={meta.cardStatus}
              register={register(meta.cardStatus.name)}
              hasError={errors[meta.cardStatus.name]}
            />
          </CustomFormControl>

          <CustomFormControl
            label={meta.cardType.label}
            isLoading={isLoading}
            isInvalid={!!errors[meta.cardType.name]}
          >
            <CustomInputSelect
              meta={meta.cardType}
              register={register(meta.cardType.name)}
              hasError={errors[meta.cardType.name]}
            />
          </CustomFormControl>

          <CustomFormControl
            label={meta.cardStatusPattern.label}
            isLoading={isLoading}
            isInvalid={!!errors[meta.cardStatusPattern.name]}
          >
            <CustomInputSelect
              meta={meta.cardStatusPattern}
              register={register(meta.cardStatusPattern.name)}
              hasError={errors[meta.cardStatusPattern.name]}
            />
          </CustomFormControl>

          <CustomFormControl
            label={meta.startDate.label}
            isLoading={isLoading}
            isInvalid={!!errors[meta.startDate.name]}
          >
            <CustomTextInput
              meta={meta.startDate}
              register={register(meta.startDate.name)}
              hasError={errors[meta.startDate.name]}
            />
          </CustomFormControl>

          <CustomFormControl
            label={meta.endDate.label}
            isLoading={isLoading}
            isInvalid={!!errors[meta.endDate.name]}
          >
            <CustomTextInput
              meta={meta.endDate}
              register={register(meta.endDate.name)}
              hasError={errors[meta.endDate.name]}
            />
          </CustomFormControl>

        </CC.SimpleGrid>

        <CC.Flex justify={'flex-end'}>
          <CustomButton isLoading={isSubmitting} type="submit" mr="4">
          <FaPrint style={{ marginRight: '10px' }} /> Imprimer
          </CustomButton>
        </CC.Flex>

      </form>
    </>
  );
};
